const CFF = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="1280"
    height="1280"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(969)"
      d="m0 0h112l58 6 46 6 35 6 41 9 32 8 31 9 43 14 42 16 37 16 38 18 25 13 24 14 23 13 23 15 16 10 14 10 18 13 14 10 16 13 13 10 26 22 10 9 8 7 16 15 11 11 8 7 12 13 13 13 7 8 11 12 9 11 10 11 20 25 10 13 14 19 13 19 8 11 13 20 16 26 16 28 11 20 8 16 13 27 16 36 12 30 13 36 10 31 10 35 10 41 8 40 7 45 5 44 4 43v115l-4 36-7 56-6 36-8 38-9 36-10 35-12 36-10 28-12 30-11 25-13 28-16 32-13 23-12 21-13 21-9 14-10 15-13 19-8 11-12 16-22 28-12 14-9 11-15 16-7 8-12 13-34 34h-2v2l-8 7-15 14-11 9-10 9-11 9-15 12-13 10-16 12-17 12-16 11-20 13-19 12-26 15-25 14-35 18-33 15-30 13-43 16-36 12-50 14-43 10-43 8-42 6-45 5-29 2h-102l-52-5-49-6-37-6-48-10-35-9-44-13-35-12-26-10-29-12-35-16-29-14-28-15-24-14-20-12-22-14-20-14-17-12-19-14-10-8-14-11-11-9-14-12-15-13-13-12-8-8-8-7-30-30-7-8-11-11-9-11-10-11-7-8-13-16-13-17-11-14-12-17-13-18-11-17-14-22-9-15-15-26-14-26-17-34-13-29-15-37-14-38-14-44-11-42-9-39-8-45-6-45-6-61v-112l5-50 4-34 7-44 10-48 9-36 11-38 14-41 12-32 18-42 10-22 8-16 13-25 13-23 16-27 9-14 11-17 8-12 13-18 12-17 11-14 12-15 7-9 13-15 9-11 12-13 7-8 7-7 7-8 31-31 8-7 14-13 11-9 11-10 11-9 14-11 15-12 16-12 17-12 20-14 16-10 20-13 29-17 24-13 29-15 32-15 33-14 34-13 47-16 42-12 33-8 39-8 49-8 32-4 41-4z"
      fill="#FDD2A1"
    />
    <path
      transform="translate(667,308)"
      d="m0 0h19l35 4 29 6 28 8 31 13 23 11 27 16 16 11 16 12 11 9 13 11 17 16 13 13 7 8 11 12 11 14 8 11 8 12 12 17 13 21 16 29 16 33 14 34 13 37 12 42 8 36 6 35 2 14v7l8-7 12-11 11-9 15-13 14-11 20-15 20-14 16-10 18-11 17-10 16-8 31-15 30-12 36-12 30-8 34-7 30-4 26-2h37l32 3 30 5 28 7 24 8 30 13 23 12 27 18 11 7 10 9 11 9 19 19 9 11 11 13 9 12 12 19 7 12 14 28 11 27 9 27 7 27 5 26 3 22 2 18 1 19v52l-3 34-5 35-7 36-9 35-9 29-10 28-10 24-11 25-19 38-14 24-12 20-23 34-13 18-13 16-16 20-10 11-7 8-9 10-16 17-7 7-8 7-9 9-8 7-10 9-14 11-13 11-19 14-20 14-17 11-20 12-25 14-32 16-24 10-29 11-40 12-36 8-32 5-21 2h-62l-32-4-33-7-23-6-28-11-27-13-27-16-12-9-14-12-9-7-15-14-8-8-7-8-12-14-14-19-12-19-10-18-8-16-9-20-10-28-6-20-5-22h-3l-15 11-21 13-24 13-24 11-29 11-32 8-21 4-33 4h-16l-30-2-24-4-31-7-24-7-28-11-27-13-24-14-16-11-12-8-11-9-14-12-16-15-24-24-9-11-12-14-14-19-14-20-13-21-12-21-14-27-13-28-15-39-12-37-8-29-8-37-6-35-4-32-3-38v-72l3-46 5-41 8-43 8-34 10-34 10-29 11-28 7-16 7-15 8-16 16-29 6-9 10-16 16-23 8-10 6-8 11-12 7-9 11-12 20-20 8-7 13-11 13-10 18-13 19-12 16-9 19-10 27-11 22-7 28-7 16-3 30-4z"
      fill="#6B4225"
    />
    <path
      transform="translate(1806,781)"
      d="m0 0 7 6 13 12 191 191 8 7 3 3v2l4 2 13 13 3 2v69l-4 36-7 56-6 36-8 38-9 36-10 35-12 36-10 28-12 30-11 25-13 28-16 32-13 23-12 21-13 21-9 14-10 15-13 19-8 11-12 16-22 28-12 14-9 11-15 16-7 8-12 13-34 34h-2v2l-8 7-15 14-11 9-10 9-11 9-15 12-13 10-16 12-17 12-16 11-20 13-19 12-26 15-25 14-35 18-33 15-30 13-43 16-36 12-50 14-43 10-43 8-42 6-45 5h-17l-7-8-526-526-5-6-7-6v-2l-4-2v-2l-4-2-28-28v-2h-2v-2h-2v-2l-4-2-37-37-9-11-10-10h3l8 6 24 16 13 8 22 12 19 9 29 11 24 7 28 6 24 4 30 2h16l39-5 28-6 25-7 32-13 25-12 24-14 18-12 10-7 2 2 6 25 6 20 9 25 9 20 8 16 11 20 14 21 13 17 11 13 15 16 7 7 8 7 10 8 13 11 15 10 26 15 30 14 21 8 36 9 20 4 32 4h62l21-2 32-5 36-8 31-9 31-11 24-10 29-14 25-13 27-16 30-20 18-13 13-10 17-14 11-9 13-12 8-7 9-9 8-7 9-9 7-8 7-7 7-8 9-10 11-14 11-13 10-13 13-18 26-39 9-15 12-21 12-23 11-22 13-30 10-26 12-36 7-25 7-29 7-39 4-32 2-25v-52l-1-19-4-34-5-27-6-25-8-26-12-31-13-26-11-20z"
      fill="#F7B672"
    />
    <path
      transform="translate(1685,668)"
      d="m0 0 5 1 27 18 11 7 10 9 11 9 19 19 9 11 11 13 9 12 12 19 7 12 14 28 11 27 9 27 7 27 5 26 3 22 2 18 1 19v52l-3 34-5 35-7 36-9 35-9 29-10 28-10 24-11 25-19 38-14 24-12 20-23 34-13 18-13 16-16 20-10 11-7 8-9 10-16 17-7 7-8 7-9 9-8 7-10 9-14 11-13 11-19 14-20 14-17 11-20 12-25 14-32 16-24 10-29 11-40 12-36 8-32 5-21 2h-62l-32-4-33-7-23-6-28-11-27-13-27-16-12-9-14-12-9-7-15-14 3-14 17-66 13-52 9-29 8-20 8-16 9-17 13-19 14-18 5-6h2l2-4 9-9 8-7 13-11 4-1 1-3 8-6h3v-2l4-3h3v-2l25-15 21-10 25-9 29-9 25-7 44-13 10-2 1-4 20-26 28-38 14-18 10-14 13-18 13-17 4-6v-18l-1-25v-60l3-22 6-28 11-33 11-24 10-18 10-15 8-11 12-14 9-11 16-15h2v-2l10-8h3l2-4 16-12 19-14 36-26 19-14 16-12 18-13 19-14 4-1z"
      fill="#6C4326"
    />
    <path
      transform="translate(625,312)"
      d="m0 0 3 1-3 9-8 26-15 49-22 70-8 28-5 22-3 23-1 17v23l2 25 4 26 6 23 7 20 11 25 10 18 1 3h2l1 5h2v3h2v3h2l2 6 3 1v3h2l4 7 3 2v3l4 2 1 3 3 2 3 5 4 4v2l4 2 5 6 1 3 3 2 1 3 3 2 3 5 5 6v2l4 2 12 16 10 17 6 15 4 16 2 16v11l-2 16-6 21-9 19-8 12-9 12-2 3h-2l-1 4-11 14-14 19-13 18-10 13-9 12-13 18-12 20-10 19-10 25-7 22-6 29-2 15-1 13v39l3 26 5 26 11 33 13 32 36 86 3 6v4h2l1 4-14-2-30-7-22-7-24-9-29-14-24-14-16-11-12-8-11-9-14-12-16-15-24-24-9-11-12-14-14-19-14-20-13-21-12-21-14-27-13-28-15-39-12-37-8-29-8-37-6-35-4-32-3-38v-72l3-46 5-41 8-43 8-34 10-34 10-29 11-28 7-16 7-15 8-16 16-29 6-9 10-16 16-23 8-10 6-8 11-12 7-9 11-12 20-20 8-7 13-11 13-10 18-13 19-12 16-9 19-10 27-11 22-7 28-7 16-3z"
      fill="#8F5F3E"
    />
    <path
      transform="translate(1486,621)"
      d="m0 0h37l32 3 30 5 28 7 24 8 30 13 19 10-3 5-11 7-13 10-17 12-13 10-18 13-19 14-14 10-19 14-24 18-1 2-5 3-6 5h-2v2l-8 7-11 10-9 11-12 14-12 18-9 15-10 19-10 25-8 26-6 29-2 17v60l1 25v18l-10 14-10 13-13 18-14 19-14 18-10 14-12 16-20 26-1 3-13 4-89 26-26 9-20 9-15 8-14 9h-2v2l-5 3h-2v2l-7 4-7 6-9 7-12 11-8 7-5 6h-2l-2 4-7 8-9 12-14 21-13 24-10 24-8 25-9 35-19 75-7 27h-3l-16-17-11-14-12-16-12-19-10-18-8-16-9-20-10-28-6-20-5-22 1-4 16-13 10-9 8-7 7-7 7-6 1-2h2l2-4 10-10 7-8 14-17 10-13 10-14 9-13 15-24 12-21 8-16 14-29 12-30 11-31 11-37 7-28 8-41 5-37 3-40 1-25v-37l-1-37-3-40v-5l8-7 12-11 11-9 15-13 14-11 20-15 20-14 16-10 18-11 17-10 16-8 31-15 30-12 36-12 30-8 34-7 30-4z"
      fill="#8F5F3E"
    />
    <path
      transform="translate(1685,668)"
      d="m0 0 5 1 27 18 11 7 10 9 11 9 19 19 9 11 11 13 9 12 2 6-13 9-19 14-28 20-19 14-14 10-19 14-17 12-19 14-16 12-13 10-10 9-7 7-9 13-8 14-7 19-4 20v28l2 50v59l-4 28-5 22-9 27-12 27-12 21-10 15-10 13-12 14-23 23-11 9-19 14-20 12-15 8-23 10-36 12-44 13-25 7-23 7-19 6-15 6-11 6-11 8-12 11-8 9-10 16-8 18-8 28-16 65-14 56-9 34-2 13-7-1-21-8-28-13-23-13-19-13-15-13-9-7-15-14 3-14 17-66 13-52 9-29 8-20 8-16 9-17 13-19 14-18 5-6h2l2-4 9-9 8-7 13-11 4-1 1-3 8-6h3v-2l4-3h3v-2l25-15 21-10 25-9 29-9 25-7 44-13 10-2 1-4 20-26 28-38 14-18 10-14 13-18 13-17 4-6v-18l-1-25v-60l3-22 6-28 11-33 11-24 10-18 10-15 8-11 12-14 9-11 16-15h2v-2l10-8h3l2-4 16-12 19-14 36-26 19-14 16-12 18-13 19-14 4-1z"
      fill="#321E10"
    />
    <path
      transform="translate(667,308)"
      d="m0 0h19l35 4 29 6 28 8 1 5-14 49-13 41-14 45-11 36-6 18-6 23-3 18v21l4 19 8 21 9 15 8 11 9 11 8 10 11 13 9 11 12 15 13 18 9 14 8 14 10 21 9 24 7 25 5 27 2 22v40l-3 26-5 23-6 21-8 21-12 25-10 17-14 20-60 80-14 19-10 16-7 16-5 17-2 11v27l5 21 6 17 11 27 15 35 5 13 5 11 13 31 11 26 9 22v2l8-2v3l-16 6-32 8-21 4-33 4h-16l-30-2-14-2-2-2v-3h-2l-4-10-11-26-35-84-10-28-4-13-5-26-3-26v-39l2-21 5-28 7-24 8-22 12-25 14-23 13-18 10-13 12-16 13-18 12-16 11-14 1-3h2l2-4 13-18 9-17 6-16 4-18 1-10v-11l-3-20-4-15-7-16-10-16-11-14-3-3-7-8-1-3-3-2-1-3-3-2-4-7-5-4-7-8-1-3-3-2-2-4-2-1-1-3-5-5-1-4h-2l-1-3-4-4v-3h-2v-3h-2v-3h-2l-1-5h-2l-8-14-8-16-10-24-8-26-4-20-3-23-1-17v-23l2-26 4-24 8-30 23-73 19-62 8-28 3-3 17-2z"
      fill="#321E10"
    />
    <path
      transform="translate(666,981)"
      d="m0 0h1l1 6v492h15v1h-16l-30-2-14-2-2-2v-3h-2l-4-10-11-26-35-84-10-28-4-13-5-26-3-26v-39l2-21 5-28 7-24 8-22 12-25 14-23 13-18 10-13 12-16 13-18 12-16z"
      fill="#503520"
    />
    <path
      transform="translate(1316,1228)"
      d="m0 0 2 1-7 11-14 18-24 32-14 19-15 20-13 18-10 13-14 19-10 13-14 19-10 13-14 19-10 13-8 11-11 15-10 13-10 14-13 17-11 15-12 16-14 19-14 18-10 14-9 12-5 1-4-1-4-4-9-5v-2l-4-1v-2h-6l-9-9 3-14 17-66 13-52 9-29 8-20 8-16 9-17 13-19 14-18 5-6h2l2-4 9-9 8-7 13-11 4-1 1-3 8-6h3v-2l4-3h3v-2l25-15 21-10 25-9 29-9 25-7 44-13z"
      fill="#503520"
    />
    <path
      transform="translate(1685,668)"
      d="m0 0 5 1 27 18v7l-10 14-12 16-28 38-9 12-14 19-75 100-14 19-21 28-14 19-9 12-13 18-13 17-14 19-10 13-12 16-11 14-10 13-2 7 1 3v23l-3 17-4 14-7 16-7 12-8 11-14 14-14 10-16 8-19 7-14 3 2-4 8-11 11-14 28-38 14-18 10-14 13-18 13-17 4-6v-18l-1-25v-60l3-22 6-28 11-33 11-24 10-18 10-15 8-11 12-14 9-11 16-15h2v-2l10-8h3l2-4 16-12 19-14 36-26 19-14 16-12 18-13 19-14 4-1z"
      fill="#503520"
    />
    <path
      transform="translate(667,308)"
      d="m0 0h19v1h-18v493l-4-5-5-5-1-3-3-2-1-3-3-2-4-7-5-4-7-8-1-3-3-2-2-4-2-1-1-3-5-5-1-4h-2l-1-3-4-4v-3h-2v-3h-2v-3h-2l-1-5h-2l-8-14-8-16-10-24-8-26-4-20-3-23-1-17v-23l2-26 4-24 8-30 23-73 19-62 8-28 3-3 17-2z"
      fill="#503520"
    />
    <path
      transform="translate(976,474)"
      d="m0 0 7 6 10 8 95 95 4 3v2l4 2 30 30 7 8 11 11 6 5 6 7 4 3v2l3 1 7 8 38 38 6 5 2 4-24 16-18 13-13 10-14 11-15 13-11 9-17 16h-2l-7-46-8-38-10-37-12-36-10-27-12-27-14-29-12-22-11-18-12-18-12-17-6-9z"
      fill="#F7B672"
    />
    <path
      transform="translate(1424,974)"
      d="m0 0h1v66l1 25v23l1 3v23l-3 17-4 14-7 16-7 12-8 11-14 14-14 10-16 8-19 7-14 3 2-4 8-11 11-14 28-38 14-18 10-14 13-18 13-17 4-6v-18l-1-25v-60z"
      fill="#6B4225"
    />
    <path
      transform="translate(668,802)"
      d="m0 0 5 5 10 13 10 17 6 15 4 16 2 16v11l-2 16-6 21-9 19-8 12-9 12-3 3-1-171z"
      fill="#6B4225"
    />
    <path
      transform="translate(1678,1472)"
      d="m0 0h2l-1 5-12 13-15 16-7 7-8 7-9 9-8 7-10 9-14 11-13 11-19 14-20 14-17 11-20 12-25 14-32 16-24 10-29 11-40 12-26 6h-9l1-4 8-3h6l8-3 9-3 7-1 8-3 11-2 7-3 8-2 5-2 11-3 15-6 4-2 9-3 38-19h2v-2l7-2v-2l7-3 13-7 10-7 8-4 5-4 8-5h2v-2l10-6 11-8 9-7 11-7 6-6h2l2-4 3-1 3-3h2v-2l5-3 5-5 4-2 2-4h2v-2h2v-2l5-4h2l1-3 4-1v-3l4-1 2-4h2l2-4 4-2v-2l7-5 5-6 5-4h2v-2l4-4 1-2h2v-2h2v-2h2v-2h2v-2z"
      fill="#472D1A"
    />
    <path
      transform="translate(966,469)"
      d="m0 0 4 2 11 13 7 8 14 20 13 21 16 29 16 33 14 34 13 37 12 42 8 36 6 35v10l-2-1-2-8-1-9-3-10-1-13-2-7-2-11-4-10v-7l-1-4-3-1v-8l-4-6-1-11-3-3-1-9-1-3h-2l-1-9-3-5-2-9-2-2-1-7-3-3-1-7-3-4-2-9h-2l-2-7-2-3v-6h-2l-4-9-8-16-7-12-6-12-3-5v-2h-2l-3-7-3-4-4-8-4-4-4-7v-2l-4-2-4-9-4-4v-4h-2l-3-6-5-5-1-4h-2z"
      fill="#573923"
    />
    <path
      transform="translate(252,1077)"
      d="m0 0 3 4 1 8 3 6 4 16 12 35 4 10 2 6 6 15 5 12 7 16 9 17 12 22 2 3v3h2l6 11 7 10 4 7 8 12 8 11 6 9 3 3v2h2l1 4h2l4 6v2h2l6 8v2l-3-1-9-11-12-15-13-18-12-18-13-21-10-18-12-23-14-30-15-39-12-37-6-22z"
      fill="#764B2D"
    />
    <path
      transform="translate(1678,1472)"
      d="m0 0h2l-1 5-12 13-15 16-7 7-8 7-9 9-8 7-10 9-14 11-13 11-2-1-1-3 7-7 3-4 3-1 3-3h2v-2l5-3 5-5 4-2 2-4h2v-2h2v-2l5-4h2l1-3 4-1v-3l4-1 2-4h2l2-4 4-2v-2l7-5 5-6 5-4h2v-2l4-4 1-2h2v-2h2v-2h2v-2h2v-2z"
      fill="#5A3B24"
    />
    <path
      transform="translate(276,625)"
      d="m0 0 1 3-7 19-8 25-8 27-9 39-7 38-5 41-3 46v72l1 12v12h-1l-2-21-1-18v-65l3-35 3-26 5-33 7-35 8-32 9-30 11-32z"
      fill="#F7B672"
    />
    <path
      transform="translate(1413,1657)"
      d="m0 0m-4 1 3 1-1 2 2 2-19 7-37 11-26 6h-9l1-4 8-3h6l8-3 9-3 7-1 8-3 11-2 7-3 8-2 5-2z"
      fill="#533721"
    />
    <path
      transform="translate(883,1399)"
      d="m0 0 3 1-2 4-20 14-20 12-22 12-24 11-10 4h-3v-2l6-3 3-2h5v-2l10-5h5l1-3 8-4h5l2-4 4-1v-2l11-6h3v-2l10-6 10-7 9-5h2v-2z"
      fill="#4E321E"
    />
    <path
      transform="translate(849,362)"
      d="m0 0 5 1 21 14 16 12 11 9 13 11 17 16 13 13 5 7-7-2-1-3h-3l-9-9v-2l-4-2-8-8-3-5v-2h-2v-2h-2v-2h-2v-2l-6-2-7-6v-2l-4-2v-2l-12-6v-2l-4-2-3-3-2-1v-2h-4v-2l-4-2-7-5-7-4z"
      fill="#593B24"
    />
    <path
      transform="translate(303,1217)"
      d="m0 0 3 1 6 11 10 18v3h2l6 11 7 10 4 7 8 12 8 11 6 9 3 3v2h2l1 4h2l4 6v2h2l6 8v2l-3-1-9-11-12-15-13-18-12-18-13-21-10-18-8-15z"
      fill="#74492B"
    />
    <path
      transform="translate(464,1409)"
      d="m0 0 10 6 16 10 4 3 7 3 17 9 12 5 11 5 28 10 30 8 12 3v1h-7l-26-6-22-7-24-9-29-14-24-14-15-10z"
      fill="#754B2C"
    />
    <path
      transform="translate(1586,1556)"
      d="m0 0m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-2 1 4 2-3 5-18 13-17 12-6 4-2-1 1-2-4-1 4-3h2v-2l10-6 11-8 9-7z"
      fill="#4D321D"
    />
    <path
      transform="translate(1477,1628)"
      d="m0 0h2l-1 3-6 1v2l-9 4-17 9 1 2-11 5-20 8h-6l5-6 11-4 4-2 9-3 32-16z"
      fill="#4D321D"
    />
    <path
      transform="translate(833,1432)"
      d="m0 0m-1 1 1 3-19 10-26 11h-3v-2l6-3 3-2h5v-2l10-5h5l1-3 8-4z"
      fill="#4B301C"
    />
    <path
      transform="translate(625,747)"
      d="m0 0 3 1 7 8v2l4 3v2l3 1 4 5v2h2l10 13 5 6-1 3-7-6-1-3-3-2-4-7-5-4-7-8-1-3-3-2-2-4-2-1z"
      fill="#392313"
    />
    <path
      transform="translate(1492,1622)"
      d="m0 0m-1 1m-4 1h4v3l-23 12-18 9h-5l3-3 15-8 9-3v-2l6-2 1-2z"
      fill="#442A18"
    />
    <path
      transform="translate(883,1399)"
      d="m0 0 3 1-2 4-20 14-5 2 2-6 7-6 9-5h2v-2z"
      fill="#563822"
    />
    <path
      transform="translate(1092,749)"
      d="m0 0 3 1 5 29v10l-2-1-2-8-1-9-3-10z"
      fill="#5F3E26"
    />
    <path
      transform="translate(600,709)"
      d="m0 0 5 5 6 9 2 2 2 5 7 9 2 6h-3l-1-4h-2l-1-3-4-4v-3h-2v-3h-2v-3h-2l-1-5h-2l-4-9z"
      fill="#3B2413"
    />
    <path
      transform="translate(1436,1648)"
      d="m0 0m-3 1h3l-2 4-3 3-15 6h-6l5-6 11-4 4-2z"
      fill="#4B301C"
    />
    <path
      transform="translate(564,1459)"
      d="m0 0 16 4 19 5 12 3v1h-7l-26-6-17-5z"
      fill="#764B2D"
    />
    <path
      transform="translate(1586,1556)"
      d="m0 0m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-2 1 4 2-3 5-12 9-2-1 1-2-3-1 7-7 7-4z"
      fill="#51341F"
    />
    <path
      transform="translate(1123,1676)"
      d="m0 0 12 4 9 1 1 1 7 1v2h7l5 2-4 1-15-2-22-6z"
      fill="#674329"
    />
    <path
      transform="translate(532,1447)"
      d="m0 0 9 3 22 8 1 2h-6l-26-10z"
      fill="#754A2C"
    />
    <path
      transform="translate(1564,1573)"
      d="m0 0m-1 1m4 0m-5 1h5l-2 5-14 10h-2l3-6 3-1 2-3 3-1z"
      fill="#482E1A"
    />
    <path
      transform="translate(845,1423)"
      d="m0 0 1 3-5 3v3l-6 3-3-1-4 1 3-4h3v-2z"
      fill="#4F341F"
    />
    <path
      transform="translate(849,362)"
      d="m0 0 5 1 21 14 3 3h-3l-4-2v-2h-4v-2l-4-2-7-5-7-4z"
      fill="#5E3E25"
    />
    <path
      transform="translate(1173,741)"
      d="m0 0 2 1-20 16-8 6-2-1 9-8 16-12z"
      fill="#794D2F"
    />
    <path
      transform="translate(277,1158)"
      d="m0 0 3 1 7 18-3 2-7-17z"
      fill="#754A2C"
    />
    <path
      transform="translate(1519,792)"
      d="m0 0 2 1-25 25v-3l12-13 8-7z"
      fill="#603D23"
    />
    <path
      transform="translate(1201,721)"
      d="m0 0 3 1-12 8-14 10-2-1 10-8z"
      fill="#784D2E"
    />
    <path
      transform="translate(1318,1685)"
      d="m0 0 8 2v1l-10 2h-10l3-3z"
      fill="#5F3E26"
    />
    <path
      transform="translate(1498,1616)"
      d="m0 0 3 1-3 3h-4v2l-12 6h-3v-2l7-2v-2l7-3z"
      fill="#503520"
    />
    <path
      transform="translate(464,1409)"
      d="m0 0 10 6 9 6 1 3-5-2-15-10z"
      fill="#784D2F"
    />
    <path
      transform="translate(1691,1457)"
      d="m0 0h1l-1 7-5 5-4-1 4-6z"
      fill="#5F3E26"
    />
    <path
      transform="translate(1518,1604)"
      d="m0 0 3 1-3 3h-3l-1 3-6 2-3 3-4-1 12-8z"
      fill="#503520"
    />
    <path
      transform="translate(387,1341)"
      d="m0 0 23 23h-3l-20-20z"
      fill="#754A2C"
    />
    <path
      transform="translate(1477,1628)"
      d="m0 0h2l-1 3-6 1v2l-9 4-3 2-3-1 17-10z"
      fill="#503520"
    />
    <path
      transform="translate(1542,1588)"
      d="m0 0 3 1-4 5v3l-5 2 1-3-4-1 4-3h2v-2z"
      fill="#523520"
    />
    <path
      transform="translate(484,1422)"
      d="m0 0 9 5 8 4 2 4-16-8-3-2z"
      fill="#74492B"
    />
    <path
      transform="translate(1142,765)"
      d="m0 0 2 1-14 13-6 5h-2v-2l11-9z"
      fill="#7A4E30"
    />
    <path
      transform="translate(1460,1639)"
      d="m0 0m-3 1h3v3l-10 5h-5l3-3z"
      fill="#482D1A"
    />
    <path
      transform="translate(1533,1596)"
      d="m0 0h4l-2 5-6 4-4-1 4-4z"
      fill="#452B19"
    />
    <path
      transform="translate(799,1449)"
      d="m0 0 1 3-12 5h-3v-2l6-3 3-2z"
      fill="#4A2F1B"
    />
    <path
      transform="translate(833,1432)"
      d="m0 0m-1 1 1 3-11 6-4-1z"
      fill="#4A2E1B"
    />
    <path
      transform="translate(1700,677)"
      d="m0 0 5 2 9 6v2l-5-1-3-2v-2l-5-2z"
      fill="#422917"
    />
    <path
      transform="translate(1146,1683)"
      d="m0 0h6v2h7l5 2-4 1-10-1-4-2z"
      fill="#583923"
    />
    <path
      transform="translate(1819,813)"
      d="m0 0h2l7 13 1 5h-2l-8-16z"
      fill="#503520"
    />
    <path
      transform="translate(1445,1644)"
      d="m0 0m-3 1h3l-1 3-5 2 2 2-5 2-3-1 4-5z"
      fill="#523620"
    />
    <path
      transform="translate(244,1043)"
      d="m0 0 2 2 2 8v7h-2l-2-10z"
      fill="#784C2E"
    />
    <path
      transform="translate(590,1468)"
      d="m0 0h9l12 3v1h-7l-14-3z"
      fill="#7E5132"
    />
    <path
      transform="translate(252,1077)"
      d="m0 0 3 4 1 8 1 2-1 5-2-4-2-8z"
      fill="#794E2F"
    />
    <path
      transform="translate(877,380)"
      d="m0 0 5 2 5 4v2l-7-2v-2l-4-2z"
      fill="#573922"
    />
    <path
      transform="translate(851,1422)"
      d="m0 0 1 2-4 4-4 2-4-1 4-3h2v-2z"
      fill="#472C1A"
    />
    <path
      transform="translate(1531,1596)"
      d="m0 0 2 1-4 4h-2v2l-6 1 5-5z"
      fill="#503520"
    />
    <path
      transform="translate(823,1436)"
      d="m0 0 3 1-7 4 1 2-6 2 1-5z"
      fill="#51341F"
    />
    <path
      transform="translate(1173,741)"
      d="m0 0 2 1-10 8-5 3 2-4z"
      fill="#784C2E"
    />
    <path
      transform="translate(1123,1676)"
      d="m0 0 11 4v2l-7-1-4-1z"
      fill="#634027"
    />
    <path
      transform="translate(1130,1301)"
      d="m0 0 3 1-11 9-2-1 1-2h2l1-3z"
      fill="#422917"
    />
    <path
      transform="translate(256,1092)"
      d="m0 0 3 3 1 10-3-3-1-3z"
      fill="#72482A"
    />
    <path
      transform="translate(237 1e3)"
      d="m0 0 2 4 1 13-2-4-1-1z"
      fill="#73492B"
    />
    <path
      transform="translate(241,1025)"
      d="m0 0 2 4 1 11h-2l-1-5z"
      fill="#784C2E"
    />
    <path
      transform="translate(1822,812)"
      d="m0 0 2 1 5 11v2h-2l-5-10z"
      fill="#805333"
    />
  </svg>
);
export default CFF;
